import BaseAPI from "@/apis/base/BaseAPI.js";
import BaseAPIFileStreamConfig from '@/apis/base/BaseAPIFileStreamConfig.js';

class ImportExportAPI extends BaseAPI {
    constructor() {
        super();
        this.controller = 'Import';
    }


    /**
     * Hàm đọc file nhập khẩu
     * creetedby PVHOANG
     * 30.09.2022
     */
     ConvertFileData(formData){
        let data = new FormData();
        if(formData.Files && formData.Files.length>0){
            formData.Files.forEach(file => {
                data.append(file.name, file)
            })
        }
        data.append('TemplateImportConfig',formData.TemplateImportConfig) ;

        return BaseAPIFileStreamConfig.post(`${this.controller}/convert-file-data`, data);
    }
}

export default new ImportExportAPI();